import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './AdminPages.css';

const statusColors = {
  pending: '#f59e0b',
  confirmed: '#3b82f6',
  shipped: '#8b5cf6',
  delivered: '#22c55e',
  cancelled: '#ef4444'
};

const Orders = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterStatus, setFilterStatus] = useState('');

  useEffect(() => { fetchOrders(); }, []);

  const fetchOrders = async () => {
    try {
      const res = await axios.get('/api/admin/orders');
      setOrders(res.data);
    } catch (err) {
      console.error('Error fetching orders:', err);
    } finally {
      setLoading(false);
    }
  };

  const updateStatus = async (id, status) => {
    try {
      await axios.put(`/api/admin/orders/${id}/status`, { status });
      fetchOrders();
    } catch (err) {
      alert('Error updating order status');
    }
  };

  const filtered = orders.filter(o => !filterStatus || o.status === filterStatus);

  if (loading) return <div className="admin-loading">Loading...</div>;

  return (
    <div className="admin-page admin-page-wide">
      <div className="admin-page-header">
        <div>
          <h2 className="admin-page-title">Orders</h2>
          <p className="admin-page-desc">Manage customer orders. ({orders.length} total)</p>
        </div>
      </div>

      <div className="admin-filters">
        <select value={filterStatus} onChange={e => setFilterStatus(e.target.value)} className="admin-filter-select">
          <option value="">All Statuses</option>
          {['pending', 'confirmed', 'processing', 'shipped', 'delivered', 'cancelled', 'returned'].map(s => (
            <option key={s} value={s}>{s.charAt(0).toUpperCase() + s.slice(1)}</option>
          ))}
        </select>
      </div>

      <div className="admin-page-card admin-table-card">
        <div className="admin-notifications-table">
          <table>
            <thead>
              <tr><th>Order ID</th><th>Customer</th><th>Items</th><th>Total</th><th>Status</th><th>Date</th><th>Actions</th></tr>
            </thead>
            <tbody>
              {filtered.length === 0 ? (
                <tr><td colSpan="7" className="admin-no-data">No orders yet.</td></tr>
              ) : filtered.map(order => (
                <tr key={order._id}>
                  <td><strong>#{order.orderNumber || order._id.slice(-6).toUpperCase()}</strong></td>
                  <td>{order.customerName || order.customerEmail}</td>
                  <td>{order.items?.length || 0} items</td>
                  <td><strong>{order.totalAmount ? `₹${order.totalAmount}` : '--'}</strong></td>
                  <td>
                    <span className="admin-status-badge" style={{ background: statusColors[order.status] || '#94a3b8', color: '#fff' }}>
                      {order.status}
                    </span>
                  </td>
                  <td>{new Date(order.createdAt).toLocaleDateString()}</td>
                  <td>
                    <select
                      value={order.status}
                      onChange={e => updateStatus(order._id, e.target.value)}
                      className="admin-filter-select"
                      style={{ minWidth: '120px', fontSize: '12px' }}
                    >
                      {['pending', 'confirmed', 'processing', 'shipped', 'delivered', 'cancelled', 'returned'].map(s => (
                        <option key={s} value={s}>{s.charAt(0).toUpperCase() + s.slice(1)}</option>
                      ))}
                    </select>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Orders;
